import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { nanoid } from 'nanoid';

export interface ITooltip2Props {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  // ref?: any; // Placeholder for React 19 forwarded references
  style?: any;
}

export const Tooltip2 = forwardRef<HTMLDivElement, ITooltip2Props>(
  ({
    children,
    className,
    id,
    style
  }: ITooltip2Props, ref) => {
    const tooltipId = id || `tooltip_${nanoid()}`;

    return (
      <div
        id={tooltipId}
        ref={ref}
        style={style}
        role="tooltip"
        className={classNames('mdf', 'vdl-overlay-container', 'mdf-tooltip', className)}
      >
        {children}
      </div>
    );
  }
);

Tooltip2.displayName = 'Tooltip2';
